import { Controller } from "stimulus";
import Raty from "raty-js"
import { getCSRFToken, setUpdatedCsrfMetaContent } from "../../util";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["message"]

  static values = {
    postSlug: String,
    rating: Number,
    starOnOne: String,
    starOnTwo: String,
    starOnThree: String,
    starOnFour: String,
    starOnFive: String,
    starOffOne: String,
    starOffTwo: String,
    starOffThree: String,
    starOffFour: String,
    starOffFive: String,
  }

  connect() {
    let serverRatingScore = this.ratingValue;
    let clientRatingScore = Cookies.get(`rated_${this.postSlugValue}`);

    this._initializeRatingPanel();

    // Disable rating and show message if user has rated (Server & Client)
    let rating = serverRatingScore || clientRatingScore;
    if (rating) {
      this._disableRatingAndShowScore(rating);
      this._updateRatingMessage("Thank you for rating this post!")
    }
  }

  async rate(ratingScore) {
    this._disableRatingAndShowScore(ratingScore);
    await setUpdatedCsrfMetaContent()

    let response = await fetch(`/rating/${this.postSlugValue}`, {
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRFToken()
      },
      body: JSON.stringify({
        rating_score: ratingScore,
      })
    })

    let responseMessage = await response.json();
    if (response.status === 200) {
      Cookies.set(`rated_${this.postSlugValue}`, ratingScore, { expires: 7 });
      this._updateRatingMessage(responseMessage.message);
    } else {
      this._disableRatingAndShowScore(0);
      this._updateRatingMessage(responseMessage.error);
    }
  }

  _initializeRatingPanel() {
    this.raty = new Raty(document.querySelector('#rating-form'), {
      click: (ratingScore) => this.rate(ratingScore),
      hints: ["", "", "", "", ""],
      iconRange: [
        { range: 1, on: this.starOnOneValue, off: this.starOffOneValue },
        { range: 2, on: this.starOnTwoValue, off: this.starOffTwoValue },
        { range: 3, on: this.starOnThreeValue, off: this.starOffThreeValue },
        { range: 4, on: this.starOnFourValue, off: this.starOffFourValue },
        { range: 5, on: this.starOnFiveValue, off: this.starOffFiveValue }
      ],
    }).init();
  }

  _disableRatingAndShowScore(ratingScore) {
    this.raty.readOnly(false);
    this.raty.score(ratingScore);
    this.raty.readOnly(true);
  }

  _updateRatingMessage(message) {
    this.messageTarget.firstElementChild.innerText = message
  }
}
